<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading">
            ¿Desea cerrar sesión?
            <v-spacer></v-spacer>
          </v-card-title>
          <v-container grid-list-xs>
            <v-btn color="primary" @click="cerrarSesion">Si, cerrar sesión</v-btn>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import btnLargo from "@/components/commons/btnLargo";
import fechaHoraServerServices from "@/services/fechaHoraServerServices.js";

const moment = require("moment");
require("moment/locale/es");

export default {
  components: {
    btnLargo
  },
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "Fichar", href: "/fichar" }
    ]);
  },
  mounted() {},

  data() {
    return {
      intervaloFechaCli: null,
      intervaloFechaSrv: null
    };
  },
  computed: {},
  methods: {
    cerrarSesion() {
      const { dispatch } = this.$store;
      dispatch("authentication/logout");
    }
  }
};
</script>
